module.exports = __webpack_public_path__ + "static/gallery7-c0bb99a9cbe8ea1ec4082d324f3c05fe.jpg";